import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { Subscription } from 'rxjs';
import { BackofficeService } from 'src/app/services/backoffice/home/backoffice.service';


@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit, OnDestroy {

  elements = [];
  type: string = 'instrument';
  backSubscription: Subscription;

  constructor(private router: Router, private backofficeService: BackofficeService, private spinner: NgxSpinnerService) { }

  ngOnInit(): void {

    this.getBackoffice();
  }

  ngOnDestroy(){

    this.backSubscription?.unsubscribe();
 }

  goElement( idx: number ){
    this.router.navigate( ['home',idx] );
  }

  getBackoffice(){

    this.backSubscription = this.backofficeService.getBackoffice( this.type ).subscribe({
      next: (resp) => { 
         this.elements = resp;
         console.log('Response: ' + resp); 
        },
      error: (err) => { console.log('Received an error: ' + err.message)},
      complete: () => { 
        console.log('Completed'); 
      }
    });
  }
}
